import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: none;
  padding: 8px;
  margin: 0px;
  outline: none;
  cursor: normal;

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
